import { c as _c } from "react/compiler-runtime";
import { useReadQuery } from '@apollo/client';
const useReadProductBasicDetails = queryRef => {
  const $ = _c(7);
  const {
    loading,
    error,
    data,
    refetch
  } = useReadQuery(queryRef);
  const t0 = loading || !data;
  const t1 = data?.basicDetails;
  let t2;
  if ($[0] !== data || $[1] !== error || $[2] !== loading || $[3] !== refetch || $[4] !== t0 || $[5] !== t1) {
    t2 = {
      loading: t0,
      error,
      data: t1,
      rawLoading: loading,
      rawData: data,
      refetch
    };
    $[0] = data;
    $[1] = error;
    $[2] = loading;
    $[3] = refetch;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useReadProductBasicDetails;